import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { AddressContainer } from '../../Commons/Address'

class More extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div>
                { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.title') }

                <AddressContainer
                    hasFocus={true}
                    placeFieldName={'birthPlace'}
                    departmentFieldName={'birthDepartment'}
                    countryFieldName={'birthCountry'}
                    placeLabel={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.fields.birth.place')}
                    departmentLabel={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.fields.birth.department')}
                    countryLabel={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.fields.birth.country')}
                />
                <AddressContainer
                    placeFieldName={'homePlace'}
                    departmentFieldName={'homeDepartment'}
                    countryFieldName={'homeCountry'}
                    placeLabel={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.fields.home.place')}
                    departmentLabel={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.fields.home.department')}
                    countryLabel={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_military_record.steps.more.fields.home.country')}
                />
            </div>
        )
    }
}

export default withTranslation()(More)
